export enum RolTypes {
    Edit = 'Deployment Editor',
    DeploymentOwner = 'Deployment Owner',
    OrganizationOwner = 'Organization Owner',
    View = 'View',
    CasSystem = 'CAS-System',
    Default= 'Default'
}
